import { ReactComponent as Analytics } from '../../@casino/img/analytics.svg';
import { ReactComponent as Report } from '../../@casino/img/seo-report.svg';
import { ReactComponent as Finance } from '../../@casino/img/finance.svg';
import { ReactComponent as Bonuses } from '../../@casino/img/bonuses.svg';
import { ReactComponent as Jackpot } from '../../@casino/img/jackpot.svg';
import { ReactComponent as Balance } from '../../@casino/img/dollar.svg';
import { ReactComponent as Event } from '../../@casino/img/event.svg';
import { ReactComponent as Referral } from '../../@casino/img/referral.svg';
import { ReactComponent as Game } from '../../@casino/img/game.svg';
import { ReactComponent as SearchGame } from '../../@casino/img/search.svg';
import { ReactComponent as Withdrawal } from '../../@casino/img/withdrawal.svg';
import { ReactComponent as Deposit } from '../../@casino/img/deposit.svg';
import { ReactComponent as ReportUser } from '../../@casino/img/report_user.svg';
import { ReactComponent as Verification } from '../../@casino/img/verification.svg';
import { ReactComponent as PersonalBonus } from '../../@casino/img/personal-bonus.svg';
import { ReactComponent as Cashier } from '../../@casino/img/cashier.svg';
import { ReactComponent as Tournament } from '../../@casino/img/tournament.svg';
import { pathRoutes as Routes } from './pathRoutes';
import { Allow as AllowMap} from './allow';

export const allOpenedCategory = [
    // 'cashier',
    // 'report',
    // 'game',
    // 'replenishment',
    // 'gamer',
    // 'bonuses',
    // 'withdrawal',
    // 'security',
    // 'settings'
]
const Allow = AllowMap();

export const navigationArray = (view) => [
    {
        id: 0,
        Icon: Analytics,
        field: 'organization',
        label: 'Организации',
        path: Routes.OBJECT_ORGANIZATION,
        allow: Boolean(view?.allow?.includes(Allow?.ObjectOrganization?.allow)),
    },
    {
        id: 1,
        Icon: Analytics,
        field: 'information',
        label: 'Информационная панель',
        path: Routes.INFORMATION,
        allow: Boolean(view?.allow?.includes(Allow?.InformationPanel?.allow))
    },
    {
        id: 44,
        Icon: Analytics,
        field: 'statistics',
        label: 'Статистика',
        path: Routes.STATISTICS,
        allow: view?.allow?.includes(Allow.Statistics.allow)
    },
    {
        id: 44,
        Icon: Analytics,
        field: 'cashback',
        label: 'Cashback',
        path: Routes.CASHBACK,
        allow: Boolean(view?.allow?.includes(Allow?.Statistics?.allow))
    },
    {
        id: 8,
        Icon: Jackpot,
        field: 'jackpot',
        label: 'Джекпоты',
        path: Routes.JACKPOT,
        allow: Boolean(view?.allow?.includes(Allow?.Jackpot?.allow))
    },
    {
        id: 9,
        Icon: Tournament,
        field: 'tournament',
        label: 'Турниры',
        path: Routes.TOURNAMENT_LIST,
        allow: Boolean(view?.allow?.includes(Allow?.Tournament?.allow))
    },
    {
        id: 11,
        Icon: Referral,
        field: 'referral',
        label: 'Реферальная программа',
        path: Routes.REFERRAL,
        allow: Boolean(view?.allow?.includes(Allow?.Referral?.allow))
    },
    {
        id: 12,
        Icon: Game,
        field: 'game',
        label: 'Игровые провайдеры',
        allow: Boolean((view?.allow?.includes(Allow?.GamesSearch?.allow) || view?.allow?.includes(Allow?.CreditLine?.allow) ||
            view?.allow?.includes(Allow?.HistoryReplenishment?.allow) || view?.allow?.includes(Allow?.ReportProvider?.allow))),
        children: [
            {
                id: 13,
                Icon: Event,
                field: 'providers',
                label: 'Провайдеры',
                path: Routes.PROVIDERS_LIST,
                allow: Boolean(view?.allow?.includes(Allow?.GamesSearch?.allow))
            },
            {
                id: 13,
                Icon: Event,
                field: 'game',
                label: 'Игры',
                path: Routes.GAMES_LIST,
                allow: Boolean(view?.allow?.includes(Allow?.GamesSearch?.allow))
            },
            {
                id: 13,
                Icon: Event,
                field: 'credit',
                label: 'Кредитная линия',
                path: Routes.GAMES_CREDIT,
                allow: Boolean(view?.allow?.includes(Allow?.CreditLine?.allow))
            },
            {
                id: 14,
                Icon: Event,
                field: 'history-credit',
                label: 'История пополнений',
                path: Routes.HISTORY_CREDIT,
                allow: Boolean(view?.allow?.includes(Allow?.HistoryReplenishment?.allow))
            },
            {
                id: 15,
                Icon: Event,
                field: 'report-provider',
                label: 'Отчет по провайдерам',
                path: Routes.GAMES_PROVIDER_REPORT,
                allow: Boolean(view?.allow?.includes(Allow?.ReportProvider?.allow))
            },
            {
                id: 16,
                Icon: SearchGame,
                field: 'search-game',
                label: 'Поиск по играм',
                path: Routes.GAMES_SEARCH,
                allow: Boolean(view?.allow?.includes(Allow?.GamesSearch?.allow))
            },
        ]
    },
    {
        id: 17,
        Icon: Withdrawal,
        field: 'payment_system',
        label: 'Платежные системы',
        path: Routes.PAYMENT_SYSTEM,
        allow: Boolean(view?.allow?.includes(Allow?.PaymentSystem?.allow))
    },
    {
        id: 77,
        Icon: Withdrawal,
        field: 'pinsale',
        label: 'Pinsale',
        path: Routes.PINSALE,
        allow: Boolean(view?.allow?.includes(Allow?.Pinsale?.allow))
    },
    {
        id: 18,
        Icon: Withdrawal,
        field: 'withdrawal',
        label: 'Выводы',
        allow: Boolean(view?.allow?.includes(Allow?.Withdrawals?.allow) || view?.allow?.includes(Allow?.WithdrawalsOperations?.allow)),
        children: [
            {
                id: 19,
                Icon: Withdrawal,
                label: 'Выводы',
                field: 'withdrawals-output',
                path: Routes.WITHDRAWALS,
                allow: Boolean(view?.allow?.includes(Allow?.Withdrawals?.allow))
            },
            {
                id: 20,
                Icon: Withdrawal,
                label: 'Неподтвержденные операции',
                field: 'withdrawals-operation',
                path: Routes.WITHDRAWALS_OPERATION,
                allow: Boolean(view?.allow?.includes(Allow?.WithdrawalsOperations?.allow))
            }
        ]
    },
    {
        id: 21,
        Icon: Deposit,
        field: 'replenishment',
        label: 'Пополнения',
        allow: Boolean(view?.allow?.includes(Allow?.GamerReport?.allow) || view?.allow?.includes(Allow?.ReplenishmentReport?.allow)),
        children: [
            {
                id: 22,
                Icon: Deposit,
                label: 'Отчет по игрокам и платежным методам',
                field: 'replenishment-gamer',
                path: Routes.REPLENISHMENT_GAMER_REPORT,
                allow: Boolean(view?.allow?.includes(Allow?.GamerReport?.allow))
            },
            {
                id: 23,
                Icon: Deposit,
                label: 'Отчет по платежам',
                field: 'replenishment-payment',
                path: Routes.REPLENISHMENT_REPORT,
                allow: Boolean(view?.allow?.includes(Allow?.ReplenishmentReport?.allow))
            },
            {
                id: 24,
                Icon: Deposit,
                label: 'Общий отчёт',
                field: 'general-payment',
                path: Routes.REPLENISHMENT_GENERAL_REPORT,
                allow: Boolean(view?.allow?.includes(Allow?.ReplenishmentReport?.allow))
            },
            {
                id: 25,
                Icon: Deposit,
                label: 'Транзакции',
                field: 'transaction',
                path: Routes.REPLENISHMENT_TRANSACTION,
                allow: Boolean(view?.allow?.includes(Allow?.ReplenishmentReport?.allow))
            }
        ]
    },
    {
        id: 24,
        Icon: ReportUser,
        field: 'mailing',
        label: 'Рассылка',
        path: Routes.MAILING_LIST,
        allow: Boolean(view?.allow?.includes(Allow?.Mailing?.allow))
    },
    {
        id: 24,
        Icon: ReportUser,
        field: 'report-user',
        label: 'Игроки',
        path: Routes.GAMER_REPORT,
        allow: Boolean(view?.allow?.includes(Allow?.Gamer?.allow))
    },
    {
        id: 25,
        Icon: Bonuses,
        field: 'bonuses',
        label: 'Бонусы',
        allow: Boolean(view?.allow?.includes(Allow?.Bonuses?.allow) || view?.allow?.includes(Allow?.PersonalBonuses?.allow) ||
            view?.allow?.includes(Allow?.PresentConfirmation?.allow) || view?.allow?.includes(Allow?.Freespin?.allow)),
        children: [
            {
                id: 26,
                Icon: Bonuses,
                label: 'Бонусы',
                field: 'bonuses-list',
                path: Routes.BONUS,
                allow: Boolean(view?.allow?.includes(Allow?.Bonuses?.allow))
            },
            {
                id: 45,
                Icon: PersonalBonus,
                label: "Pinsale",
                field: 'pinsale',
                path: Routes.PINSALE,
                allow: view?.allow?.includes(Allow?.Pinsale?.allow)
            },
            {
                id: 27,
                Icon: PersonalBonus,
                label: 'Выдача персональных бонусов',
                field: 'personal-bonus',
                path: Routes.PERSONAL_BONUS,
                allow: Boolean(view?.allow?.includes(Allow?.PersonalBonuses?.allow))
            },
            {
                id: 28,
                Icon: PersonalBonus,
                label: 'Подтверждение подарков',
                field: 'present-confirmation',
                path: Routes.PRESENT_CONFIRMATION,
                allow: Boolean(view?.allow?.includes(Allow?.PresentConfirmation?.allow))
            },
            {
                id: 29,
                Icon: PersonalBonus,
                label: 'Фриспины',
                field: '/freespin/list',
                path: Routes.FREESPIN_LIST,
                allow: Boolean(view?.allow?.includes(Allow?.Freespin?.allow))
            },
            {
                id: 30,
                Icon: PersonalBonus,
                label: 'Фриспины игры',
                field: '/freespin/game',
                path: Routes.FREESPIN_GAME,
                allow: Boolean(view?.allow?.includes(Allow?.Freespin?.allow))
            }
        ]
    },
    {
        id: 31,
        Icon: Cashier,
        field: 'cashier',
        label: 'Касса',
        allow: Boolean(view?.allow?.includes(Allow?.CashierUsers?.allow) || view?.allow?.includes(Allow?.CashierReport?.allow) ||
            view?.allow?.includes(Allow?.CashierFinance?.allow) || view?.allow?.includes(Allow?.CashierGroup?.allow)),
        children: [
            {
                id: 32,
                Icon: Cashier,
                label: 'Кассиры',
                field: 'cashiers',
                path: Routes.CASHIER_USERS,
                allow: Boolean(view?.allow?.includes(Allow?.CashierUsers?.allow))
            },
            {
                id: 33,
                Icon: Event,
                label: 'Отчет по сменам',
                field: 'report-cashiers',
                path: Routes.CASHIER_SHIFT,
                allow: Boolean(view?.allow?.includes(Allow?.CashierReport?.allow))
            },
            {
                id: 34,
                Icon: Event,
                label: 'Финансовые операции',
                field: 'report-daily',
                path: Routes.CASHIER_DAILY,
                allow: Boolean(view?.allow?.includes(Allow?.CashierFinance?.allow))
            },
            {
                id: 35,
                Icon: Event,
                label: 'Группы',
                field: 'report-group',
                path: Routes.CASHIER_GROUP,
                allow: Boolean(view?.allow?.includes(Allow?.CashierGroup?.allow))
            }
        ]
    },
    {
        id: 36,
        Icon: Verification,
        field: 'support',
        label: 'Тех. поддержка',
        path: Routes.SUPPORT,
        allow: Boolean(view?.allow?.includes(Allow?.Support?.allow))
    },
    {
        id: 37,
        Icon: Verification,
        field: 'security',
        label: 'Безопасность',
        allow: Boolean(view?.allow?.includes(Allow?.SecurityAdmin?.allow) || view?.allow?.includes(Allow?.SecurityHistorySignin?.allow) ||
            view?.allow?.includes(Allow?.SecurityHistoryEvent?.allow)),
        children: [
            {
                id: 38,
                Icon: Event,
                field: 'list-admin',
                label: 'Администраторы',
                path: Routes.SECURITY_ADMIN_LIST,
                allow: Boolean(view?.allow?.includes(Allow?.SecurityAdmin?.allow))
            },
            {
                id: 39,
                Icon: Event,
                field: 'signin',
                label: 'История входов',
                path: Routes.SECURITY_SIGNIN_HISTORY,
                allow: Boolean(view?.allow?.includes(Allow?.SecurityHistorySignin?.allow))
            },
            {
                id: 40,
                Icon: Event,
                field: 'event',
                label: 'История действий',
                path: Routes.SECURITY_EVENT_HISTORY,
                allow: Boolean(view?.allow?.includes(Allow?.SecurityHistoryEvent?.allow))
            }
        ]
    },
    {
        id: 41,
        Icon: Verification,
        field: 'settings',
        label: 'Настройки',
        allow: Boolean(view?.allow?.includes(Allow?.SettingsMessanger?.allow) || view?.allow?.includes(Allow?.SettingsExchange?.allow)),
        children: [
            {
                id: 42,
                Icon: Event,
                field: 'messanger',
                label: 'Месенджеры',
                path: Routes.SETTINGS_MESSANGER,
                allow: Boolean(view?.allow?.includes(Allow?.SettingsMessanger?.allow))
            },
            {
                id: 43,
                Icon: Event,
                field: 'exchangeRates',
                label: 'Курсы валют',
                path: Routes.SETTINGS_EXCHANGE,
                allow: Boolean(view?.allow?.includes(Allow?.SettingsExchange?.allow))
            },
            {
                id: 46,
                Icon: Event,
                field: 'code',
                label: 'Код страны',
                path: Routes.CODE_COUNTRY,
                allow: Boolean(view?.allow?.includes(Allow?.SettingsCodeCountry?.allow))
            },
            {
                id: 47,
                Icon: Event,
                field: 'currency',
                label: 'Валюта',
                path: Routes.CURRENCY_LIST,
                allow: Boolean(view?.allow?.includes(Allow?.SettingsCurrency?.allow))
            },
            {
                id: 48,
                Icon: Event,
                field: 'dictionary',
                label: 'Справочник',
                path: Routes.DICTIONARY_LIST,
                allow: true,
            },
            {
                id: 48,
                Icon: Event,
                field: 'rules',
                label: 'Правила',
                path: Routes.RULES_LIST,
                allow: false
            }
        ]
    }
];